// material-ui
import { useTheme } from "@mui/material/styles";

import logoIconDark from "assets/images/jobssy_logo.png";
import logoIcon from "assets/images/jobssy_logo.png";
import { ThemeMode } from "types/config";
import { useGetMenuMaster } from "api/menu";
import miniLogo from "assets/images/miniLogo.jpg";

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = ({ width = "100" }: any) => {
  const theme = useTheme();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  return (
    <img
      src={
        !drawerOpen
          ? miniLogo
          : theme.palette.mode === ThemeMode.DARK
          ? logoIconDark
          : logoIcon
      }
      alt="Syria Jobs"
      width={drawerOpen ? "100" : "20"}
    />
  );
};

export default LogoIcon;
